import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar'; // Assuming Navbar is in the same directory or adjust path
import Footer from './Footer'; // Assuming Footer is in the same directory or adjust path

const MainLayout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        {/* Outlet renders the matched child route's component */}
        <Outlet /> 
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
